import {
  FETCH_CASHBACK_SUCCESS,
  FETCH_CASHBACK_START,
  FETCH_CASHBACK_FAILED
} from "./actionTypes";

const initalState = {
  loading: false,
  error: false,
  data: [],
  count: 0,
  paginationResult: {},
  totalCashback: "0.00",
};
const casehbackReducer = (state = initalState, action) => {

  switch (action.type) {
    case FETCH_CASHBACK_START:
      state = {
        ...state,
        loading: true,
      };
      break;
    case FETCH_CASHBACK_SUCCESS: {
      const { docs = [], totalCashback = "0.00", ...other } = action.payload;
      state = {
        ...state,
        loading: false,
        data: docs,
        count: docs.length,
        paginationResult: other,
        totalCashback,
      };
      break;
    }
    case FETCH_CASHBACK_FAILED:
      state = {
        ...state,
        loading: false,
        error: true,
      };
      break;
    default:
      state = { ...state };

  }
  return state;
};

export default casehbackReducer;
